    // This replaces placeholder tokens like #design.title# using values from a data object
    export const ReplacePlaceholders = (input, data) => {

        // If the input is not a string just return it unchanged
        if (typeof input !== "string") {

            return input;

        }

        // Replace every #something.path# token found in the string
        return input.replace(/#(.*?)#/g, (fullMatch, tokenPath) => {

            // Split the token path into parts using dot notation
            const pathParts = tokenPath.split(".");

            // Start from the root data object
            let currentValue = data;

            // Walk through the object path safely
            for (const part of pathParts) {

                // If we can keep drilling into the object, do it
                if (currentValue && typeof currentValue === "object" && part in currentValue) {

                    currentValue = currentValue[part];

                }

                // If the path does not exist, return the original placeholder
                else {

                    return fullMatch;

                }

            }

            // If the final value is null or undefined, keep the original placeholder
            if (currentValue === null || currentValue === undefined) {

                return fullMatch;

            }

            // Return the resolved value as a string
            return String(currentValue);

        });

    };



    // This loops through an object and replaces placeholders in all string values
    export const ReplacePlaceholdersInObject = (obj, data) => {

        // If this is an array, map through each item
        if (Array.isArray(obj)) {

            return obj.map((item) => ReplacePlaceholdersInObject(item, data));

        }

        // If this is a plain object, rebuild it with processed values
        if (obj && typeof obj === "object") {

            return Object.fromEntries(

                Object.entries(obj).map(([key, value]) => [

                    key,

                    ReplacePlaceholdersInObject(value, data),

                ])

            );

        }

        // If this is a string, replace placeholders
        if (typeof obj === "string") {

            return ReplacePlaceholders(obj, data);

        }

        // Otherwise return the value unchanged
        return obj;

    };
